import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  getSingleMebershipId,
  updateMembership,
} from "../../../redux/membership/action";
import { addMembershipValidation } from "../../Constant/constant";
import Spinner from "../../Layouts/Spinner";
import "../../Common/Styles/AdminEnhancements.css";
import {
  MEMBERSHIP_MARKETING_FEATURES,
  membershipMarketingFeaturesFromPlan,
} from "./membershipFeatures";

const UpdateMembership = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectdurationtype, setselectdurationtype] = useState("");
  const [loading, setLoading] = useState(false);
  const singleMembership = useSelector(
    (state) => state?.reusableSlice?.singleMembership
  );

  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getSingleMebershipId(id));
    }
  }, [id]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: singleMembership?.title || "",
      ar_title: singleMembership?.ar_title || "",
      max_invoices: singleMembership?.max_invoices || "",
      max_invoices1: singleMembership?.max_invoices1 || "",
      max_invoices2: singleMembership?.max_invoices2 || "",
      max_invoices3: singleMembership?.max_invoices3 || "",
      max_invoices4: singleMembership?.max_invoices4 || "",
      duration_type: singleMembership?.duration_type || "",
      duration: singleMembership?.duration || 1,
      price: singleMembership?.price || 0,
      dollar_price: singleMembership?.dollar_price || 0,
      discount: singleMembership?.discount || 0,
      status: singleMembership?.status || 1,
      support_regular: singleMembership?.support_regular || 0,
      ...membershipMarketingFeaturesFromPlan(singleMembership),
    },
    validationSchema: addMembershipValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      id: singleMembership?.id,
    };
    dispatch(updateMembership(data, setLoading, navigate));
  };

  const handleGenderChange = (e) => {
    const gender = e.target.value;
    setselectdurationtype(gender);
    formik.setFieldValue("duration_type", Number(gender));
  };

  const handleStatusChange = (e) => {
    formik.setFieldValue("status", Number(e.target.value));
  };

  return (
    <div className="p-3">
      <div className=" category-wrapper">
        <h3 className="pb-2">Update Membership</h3>
        <div className="admin-highlight-box mb-3">Admin membership setup uses website-facing labels here: Monthly and Semi-Annual.</div>
        <form onSubmit={formik.handleSubmit}>
          <p className="bredcrumbs">
            <a onClick={() => navigate("/")}>Home &gt;</a>{" "}
            <a onClick={() => navigate("/membership")}>Membership &gt;</a>{" "}
            Update Membership
          </p>
          <div className="row ">
            <div className="col-md-5">
              <div className="col-md-12 form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter title"
                  name="title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.title}
                />
                {formik.touched.title && formik.errors.title ? (
                  <div className="error">{formik.errors.title}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Ar Title</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter ar title"
                  name="ar_title"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.ar_title}
                />
                {formik.touched.ar_title && formik.errors.ar_title ? (
                  <div className="error">{formik.errors.ar_title}</div>
                ) : null}
              </div>

              {/* <div className="col-md-12 form-group">
                        <label>Max Invoices</label>
                        <input
                            type="number"
                            className="form-control"
                            placeholder="Enter invoices..."
                            name="max_invoices"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.max_invoices}
                        />
                        {formik.touched.max_invoices && formik.errors.max_invoices ? (
                            <div className="error">{formik.errors.max_invoices}</div>
                        ) : null}
                    </div> */}
              <div className="form-group col-md-12">
                <label htmlFor="duration_type">Duration Type</label>
                <select
                  id="duration_type"
                  name="duration_type"
                  className="form-control"
                  onChange={handleGenderChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration_type}
                >
                  <option value="">Select Duration</option>
                  <option value="1">Monthly</option>
                  <option value="2">Semi-Annual</option>
                </select>
                {formik.touched.duration_type && formik.errors.duration_type ? (
                  <div className="error">{formik.errors.duration_type}</div>
                ) : null}
              </div>
              <div className="form-group col-md-12">
                <label htmlFor="status">Status</label>
                <select
                  id="status"
                  name="status"
                  className="form-control"
                  onChange={handleStatusChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.status}
                >
                  <option value={1}>Active</option>
                  <option value={2}>Inactive</option>
                </select>
                {formik.touched.status && formik.errors.status ? (
                  <div className="error">{formik.errors.status}</div>
                ) : null}
              </div>
              {/* <div className="col-md-12 form-group">
                <label>Duration</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter duration"
                  name="duration"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.duration}
                />
                {formik.touched.duration && formik.errors.duration ? (
                  <div className="error">{formik.errors.duration}</div>
                ) : null}
              </div> */}

              <div className="col-md-12 form-group">
                <label>Website Price (SAR)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter SAR price"
                  name="price"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.price || 0}
                />
                {formik.touched.price && formik.errors.price ? (
                  <div className="error">{formik.errors.price}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Shopify Price (USD)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter USD price"
                  name="dollar_price"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.dollar_price || 0}
                />
                {formik.touched.dollar_price && formik.errors.dollar_price ? (
                  <div className="error">{formik.errors.dollar_price}</div>
                ) : null}
              </div>
              <div className="col-md-12 form-group">
                <label>Discount % (Optional)</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter discount"
                  name="discount"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.discount}
                />
                {formik.touched.discount && formik.errors.discount ? (
                  <div className="error">{formik.errors.discount}</div>
                ) : null}
              </div>
            </div>
            <div className="table-responsive col-md-7">
              <table className="table">
                <thead>
                  <th>Invoice Type</th>
                  <th>Limited Number</th>
                  <th>Unlimited Number</th>
                </thead>
                <tbody>
                  <tr>
                    <td>Simplified</td>
                    <td>
                      {formik.values.max_invoices !== 10000 && (
                        <>
                          <input
                            type="number"
                            className={`form-control ${
                              formik.touched.max_invoices &&
                              formik.errors.max_invoices
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Enter invoice..."
                            name="max_invoices"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.max_invoices}
                          />
                          {formik.touched.max_invoices &&
                            formik.errors.max_invoices && (
                              <div className="error">
                                {formik.errors.max_invoices}
                              </div>
                            )}
                        </>
                      )}
                    </td>
                    <td className="checkbox-input">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          formik.setFieldValue(
                            "max_invoices",
                            e.target.checked ? 10000 : ""
                          );
                        }}
                        checked={formik.values.max_invoices === 10000}
                      />
                    </td>
                  </tr>

                  <tr>
                    <td>VAT</td>
                    <td>
                      {formik.values.max_invoices1 !== 10000 && (
                        <>
                          <input
                            type="number"
                            className={`form-control ${
                              formik.touched.max_invoices1 &&
                              formik.errors.max_invoices1
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Enter invoice..."
                            name="max_invoices1"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.max_invoices1}
                          />
                          {formik.touched.max_invoices1 &&
                            formik.errors.max_invoices1 && (
                              <div className="error">
                                {formik.errors.max_invoices1}
                              </div>
                            )}
                        </>
                      )}
                    </td>
                    <td className="checkbox-input">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          formik.setFieldValue(
                            "max_invoices1",
                            e.target.checked ? 10000 : ""
                          );
                        }}
                        checked={formik.values.max_invoices1 === 10000}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>Purchase</td>
                    <td>
                      {formik.values.max_invoices2 !== 10000 && (
                        <>
                          <input
                            type="number"
                            className={`form-control ${
                              formik.touched.max_invoices2 &&
                              formik.errors.max_invoices2
                                ? "is-invalid"
                                : ""
                            }`}
                            placeholder="Enter invoice..."
                            name="max_invoices2"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.max_invoices2}
                          />
                          {formik.touched.max_invoices2 &&
                            formik.errors.max_invoices2 && (
                              <div className="error">
                                {formik.errors.max_invoices2}
                              </div>
                            )}
                        </>
                      )}
                    </td>
                    <td className="checkbox-input">
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          formik.setFieldValue(
                            "max_invoices2",
                            e.target.checked ? 10000 : ""
                          );
                        }}
                        checked={formik.values.max_invoices2 === 10000}
                      />
                    </td>
                  </tr>

                  <tr>
                      <td>Credit Notes</td>
                      <td>
                        {formik.values.max_invoices3 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter credit note..."
                              name="max_invoices3"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices3}
                            />
                            {formik.touched.max_invoices3 &&
                              formik.errors.max_invoices3 && (
                                <div className="error">
                                  {formik.errors.max_invoices3}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices3",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices3 === 10000}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td>Debit Notes</td>
                      <td>
                        {formik.values.max_invoices4 !== 10000 && (
                          <>
                            <input
                              type="number"
                              className={`form-control ${
                                formik.touched.max_invoices2 &&
                                formik.errors.max_invoices2
                                  ? "is-invalid"
                                  : ""
                              }`}
                              min="0"
                              placeholder="Enter debit note..."
                              name="max_invoices4"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              value={formik.values.max_invoices4}
                            />
                            {formik.touched.max_invoices4 &&
                              formik.errors.max_invoices4 && (
                                <div className="error">
                                  {formik.errors.max_invoices4}
                                </div>
                              )}
                          </>
                        )}
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "max_invoices4",
                              e.target.checked ? 10000 : ""
                            );
                          }}
                          checked={formik.values.max_invoices4 === 10000}
                        />
                      </td>
                    </tr>
                  
                    <tr>
                      <th>Plan Benefit</th>
                      <th>Arabic Label</th>
                      <th>Included</th>
                    </tr>
                    {MEMBERSHIP_MARKETING_FEATURES.map((feature) => (
                      <tr key={feature.field}>
                        <td>{feature.label}</td>
                        <td dir="rtl">{feature.arLabel}</td>
                        <td className="checkbox-input">
                          <input
                            type="checkbox"
                            onChange={(event) => {
                              formik.setFieldValue(
                                feature.field,
                                event.target.checked ? 1 : 0
                              );
                            }}
                            checked={formik.values[feature.field] === 1}
                          />
                        </td>
                      </tr>
                    ))}
                    <tr>
                      <td>Business Hours Support</td>
                      <td>
                      </td>
                      <td className="checkbox-input">
                        <input
                          type="checkbox"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "support_regular",
                              e.target.checked ? 1 : 0
                            );
                          }}
                          checked={formik.values.support_regular === 1}
                        />
                      </td>
                    </tr>

                </tbody>
              </table>
            </div>
          </div>
          <div
            className="d-flex align-items-center justify-content-center mt-3  "
            style={{ columnGap: "20px" }}
          >
            <button
              className="submit-btn  "
              onClick={() => {
                navigate("/membership");
              }}
              style={{ width: "max-content" }}
            >
              Back
            </button>
            <button
              className="submit-btn   "
              style={{ width: "max-content" }}
              type="submit"
            >
              {!loading ? "Update" : <Spinner />}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default UpdateMembership;
